// extracted by mini-css-extract-plugin
export default {"additionalSettingsSection":"PropertyDefinitionForm-module__additionalSettingsSection--ndefk","propertyFormControl":"PropertyDefinitionForm-module__propertyFormControl--Z6LcB"};